<div class="sd-container sd-container--variant-white">
  <div class="flex-row">
    <div class="sd-headline sd-headline--size-3xl">{{ 'profile.account.headline' | transloco }}</div>

    @if (!userInfo()) {
      <sd-4-5-1-spinner></sd-4-5-1-spinner>
    } @else if (userInfo()?.pending) {
      <wct-user-pending-label />
    } @else {
      <sd-4-5-1-button
        (click)="edit()"
        variant="tertiary"
        size="sm">
        <sd-4-5-1-icon
          color="primary"
          library="{{ iconLibrary }}"
          name="system/pen"></sd-4-5-1-icon>
      </sd-4-5-1-button>
    }
  </div>

  <wct-spacer />

  @for (inputGroup of inputConfig.inputGroups; track $index) {
    <section
      [wctApiCallInject]="userInfo"
      wctProfileSection
      headlineI18n="{{ inputGroup.titleI18n }}"
      [inputs]="inputGroup.inputs"
      [userInfo]="userInfo"></section>

    @if (!$last) {
      <wct-spacer [spacingAmount]="2" />
    }
  }

  <wct-spacer [spacingAmount]="2" />

  <div class="sd-headline sd-headline--size-3xl">{{ 'profile.account.colleagues' | transloco }}</div>

  <wct-spacer />

  <div class="colleagues" [wctApiCallInject]="colleagues">
    @for (colleague of colleagues(); track $index) {
        <wct-colleague-display
          [class.colleague-admin]="colleague.admin"
          [colleague]="colleague"
          [editable]="false" />
    } @empty {
      <wct-spacer [spacingAmount]="2" />
    }
  </div>
</div>
